<template>
  <tr>
    <td>
      <v-speed-dial direction="right" v-model="menu">
        <template v-slot:activator>
          <v-btn color="blue darken-2" v-model="menu" dark fab small>
            <v-icon v-if="menu">mdi-close</v-icon>
            <v-icon v-else>mdi-cog</v-icon>
          </v-btn>
        </template>
        <v-btn fab dark small color="green" @click="edit">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn fab dark small color="red darken-3" @click="deleteMe">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-speed-dial>
    </td>
    <td :class="{hide: menu}">{{feed.startedAt | moment('HH:mm')}}</td>
    <td>
      <breast :side="feed.first" status :large="false"/>
      <breast v-if="feed.both" :side="feed.first === 'L' ? 'R' : 'L'" status :large="false"/>
    </td>
  </tr>
</template>

<script>
import Breast from './Breast';
import {mapActions} from 'vuex';
export default {
  name: 'HistoryRow',
  components: {Breast},
  props: {
    feed: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    ...mapActions('feeds', [
      'deleteFeed'
    ]),
    edit() {
      this.$emit('edit');
    },
    deleteMe() {
      this.deleteFeed(this.feed.id)
          .catch(err => this.$logger.error(err));
    }
  }
}
</script>

<style scoped>

</style>
